import { create } from 'zustand';

import { OrganizationStore } from './types';
import { persist } from 'zustand/middleware';

export const useOrganizationStore = create<OrganizationStore>()(
  persist(
    (set) => ({
      organization: undefined,
      setOrganization: (organization) => set({ organization }),
      updateOrganization: (partial) =>
        set((state) => ({
          organization: state.organization
            ? { ...state.organization, ...partial }
            : state.organization,
        })),
    }),
    {
      name: 'organization-storage',
      version: 1,
    }
  )
);
